<template>
  <div class="wrapper-dashboard">
    <div class="ui container">
      <h2>Pagamentos por dia</h2>

      <div v-if="loading" class="wrap-loding-chart">
        <t-placeholder :lines="5" />
      </div>

      <t-line-chart
        v-else
        class="chart line"
        :chart-data="chartData"
        :options="chartOptions"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex"

export default {
  components: {
    TLineChart: () => import('@/components/chart/line.js')
  },

  data () {
    return {
      loading: true,
      target: '29/Jan',
      chartData: null
    }
  },

  computed: {
    ...mapState({
      campaignId: ({ campaign }) => campaign.campaign.id,
      listCampaignData: ({ dashboard }) => dashboard.listCampaignData,
      listPaymentsByDate: ({ dashboard }) => dashboard.listPaymentsByDate,
      listCoutPaymentsByDate: ({ dashboard }) => dashboard.listCoutPaymentsByDate,
      listAmoutPaymentsByDate: ({ dashboard }) => dashboard.listAmoutPaymentsByDate,
      listDatePaymentsByDate: ({ dashboard }) => dashboard.listDatePaymentsByDate
    }),

    chartOptions () {
      return {
        annotation: {
          annotations: [
            {
              type: "line",
              mode: "vertical",
              scaleID: "x-axis-0",
              value: this.target,
              borderColor: "#fcc419",
              borderWidth: 2,
              label: {
                backgroundColor: '#fcc419',
                fontFamily: "Sarabun",
                fontSize: 13,
                fontStyle: "bold",
                fontColor: "#fff",
                xPadding: 10,
                yPadding: 6,
                cornerRadius: 3,
                content: "Vencimento",
                enabled: true,
                position: "top",
                yAdjust: 0,
              }
            }
          ]
        }
      }
    }
  },

  mounted () {
    this.getCampaignPaymentsByDateQuery({ campaignId: this.campaignId })

    setTimeout(() => {
      if (this.listAmoutPaymentsByDate.lenght > 0) {
        this.loading = true
      } else {
        this.loading = false
        this.chartDataSet()
      }
    }, 1500)
  },

  methods: {
    ...mapActions("dashboard", ["getCampaignPaymentsByDateQuery"]),

    chartDataSet () {
      this.chartData = {
        labels: this.listDatePaymentsByDate,
        datasets: [
          {
            data: this.listCoutPaymentsByDate,
            label: "Doações pagas",
            borderColor: "#339af0",
            pointBackgroundColor: "#339af0",
            fill: false,
            lineTension: 0
          },
          {
            data: this.listAmoutPaymentsByDate,
            label: "BRL em receita",
            borderColor: "#20c997",
            pointBackgroundColor: "#20c997",
            fill: false,
            lineTension: 0
          }
        ]
      }
    },

    getTarget () {
      this.target = this.listCampaignData.value
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/css/colors.scss";

.chart.line {
  border: 1px solid $gray-300;
  border-radius: 3px;
  height: 250px;
}

</style>
